import { Text } from '@chakra-ui/react'
import { FlexCol, FlexRow } from '@components'
import type { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { EmberAvatar } from './EmberAvatar'

export const EmberProfile: FC = () => {
  const navigate = useNavigate()
  return (
    <FlexRow cursor={'pointer'} alignItems={'center'} onClick={() => navigate('/ember')}>
      <EmberAvatar size='44px' />
      <FlexCol>
        <Text userSelect={'none'} fontSize={'14px'} fontWeight={500} letterSpacing={'0.21px'} color='#0A1D3D'>
          Ember
        </Text>
        <Text userSelect={'none'} fontSize={'12px'} fontWeight={500} letterSpacing={'0.18px'} color='rgba(10, 29, 61, 0.60)'>
          AI Assistant
        </Text>
      </FlexCol>
    </FlexRow>
  )
}
